import { observable, makeObservable } from 'mobx';
import { CouponIdType } from '../coupons';
import { UnifiedEventsListMarkets } from './UnifiedEventsListMarkets';
import { Common } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { SportsTimeFilterType } from 'src/domains/sportsbook/webview/components/sportEventsListNew/SportsFilters/SportsTimeFilter';

export class UnifiedEventsListSelectTabState {
    @observable public filter_coupon: CouponIdType = 'all';
    @observable public filter_inPlay: boolean = false;
    @observable public filter_outrights: boolean = false;
    @observable public filter_time: SportsTimeFilterType | null = null;
    public readonly eventsListMarkets: UnifiedEventsListMarkets;

    public constructor(
        private readonly common: Common,
        private readonly sportId: string
    ) {
        makeObservable(this);
        this.eventsListMarkets = new UnifiedEventsListMarkets(
            LanguagesState.get(this.common).getTranslation,
            this.sportId
        );
    }
}
